/* Topo da PDP · gerado por tema/topo.py (04/10). Pontos + contador da galeria, mini-caixa,
   botão do topo (computador) e a barra que só entra quando esse botão sai da tela (computador). */
(function(){
  var palco = document.getElementById('palco');
  var pts = document.querySelector('#pg-pdp .tp-pts');
  if(palco){
    var figs = [].slice.call(palco.querySelectorAll('.quadro'));
    var bts = pts ? [].slice.call(pts.querySelectorAll('.tp-pts__l button')) : [];
    var num = pts ? pts.querySelector('.tp-pts__n b') : null;
    if(pts && window.RysePecinhas) RysePecinhas.monta(pts.querySelector('.tp-pts__l'));
    var atual = 0;
    function pad(){ return parseFloat(getComputedStyle(palco).paddingLeft) || 0; }
    function qual(){
      var o = palco.getBoundingClientRect().left + pad(), m = 0, d = 1e9;
      figs.forEach(function(f, i){ var x = Math.abs(f.getBoundingClientRect().left - o); if(x < d){ d = x; m = i; } });
      return m;
    }
    function marca(i){
      if(i === atual && bts[i] && bts[i].getAttribute('aria-current') === 'true') return;
      atual = i;
      bts.forEach(function(b, k){ if(k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      if(num) num.textContent = (i < 9 ? '0' : '') + (i + 1);
    }
    function vai(i){
      var f = figs[i]; if(!f) return;
      var alvo = palco.scrollLeft + f.getBoundingClientRect().left - palco.getBoundingClientRect().left - pad();
      palco.scrollTo({ left: alvo, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      marca(i);
    }
    var rq = 0;
    palco.addEventListener('scroll', function(){ if(rq) return; rq = requestAnimationFrame(function(){ rq = 0; marca(qual()); }); }, { passive: true });
    bts.forEach(function(b, i){ b.addEventListener('click', function(){ vai(i); }); });
    document.querySelectorAll('#pg-pdp .tp-mini').forEach(function(b){
      b.addEventListener('click', function(){ vai(+b.dataset.i || 0); });
    });
    /* setas do teclado nos pontos */
    if(pts) pts.addEventListener('keydown', function(e){
      if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = Math.max(0, Math.min(figs.length - 1, atual + (e.key === 'ArrowRight' ? 1 : -1)));
      vai(i); if(bts[i]) bts[i].focus(); e.preventDefault();
    });
  }

  /* botão do topo = o botão da barra (mesmo carrinho, mesmo Leve junto, mesmos estados) */
  var tb = document.getElementById('tp-bt'), fb = document.getElementById('fx-b');
  if(tb && fb){
    tb.addEventListener('click', function(){ fb.click(); });
    /* a face visível do botão da barra (parado / adicionando / na sacola / falhou) vira o texto do botão do topo */
    var copia = function(){
      var f = fb.querySelector('.face[data-on="1"]') || fb;
      var t = (f.textContent || '').replace(/\s+/g, ' ').trim(); if(!t) return;
      t = /^adicionar$/i.test(t) ? (tb.hasAttribute('data-pv') ? 'Garantir na pré-venda' : 'Adicionar à sacola') : t;
      if(tb.textContent !== t) tb.textContent = t;
      tb.setAttribute('aria-busy', fb.getAttribute('aria-busy') || 'false');
    };
    copia();
    if(window.MutationObserver) new MutationObserver(copia).observe(fb, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-on', 'aria-busy'] });
  }

  /* computador: a barra fixa some enquanto o botão do topo está na tela. Celular: nada muda. */
  var fixa = document.querySelector('#pg-pdp .fixa');
  if(tb && fixa && 'IntersectionObserver' in window){
    var mq = matchMedia('(min-width: 960px)'), visto = true;
    var aplica = function(){ if(mq.matches && visto) fixa.setAttribute('data-tp-some', ''); else fixa.removeAttribute('data-tp-some'); };
    /* "visto" = o botão do topo ainda não passou por cima da tela (está à vista ou mais abaixo) */
    new IntersectionObserver(function(es){ var e = es[0]; visto = e.isIntersecting || e.boundingClientRect.top > 0; aplica(); }).observe(tb);
    if(mq.addEventListener) mq.addEventListener('change', aplica);
    aplica();
  }

  /* computador: a obra (miniatura, nome, artista · peças) e o preço na regra da loja entram na barra.
     O preço é cópia viva do preço do topo (#tp-p1/#tp-p2), que a troca de variante já atualiza. */
  if(fixa && !fixa.querySelector('.fixa__obra')){
    var P = window.RYSE_P || {}, faixa = fixa.querySelector('.fixa__faixa');
    var ob = document.createElement('div'); ob.className = 'fixa__obra';
    if(P.foto){ var im = document.createElement('img'); im.className = 'fixa__f'; im.src = P.foto; im.alt = ''; im.width = 56; im.height = 42; im.loading = 'lazy'; im.decoding = 'async'; ob.appendChild(im); }
    var tx = document.createElement('span'); tx.className = 'fixa__o';
    var nm = document.createElement('b'); nm.textContent = P.nome || ''; tx.appendChild(nm);
    if(P.meta){ var mt = document.createElement('span'); mt.textContent = P.meta; tx.appendChild(mt); }
    ob.appendChild(tx);
    var pd = document.createElement('div'); pd.className = 'fixa__pd';
    var p3 = document.createElement('span'); p3.className = 'fixa__3x';
    var px = document.createElement('span'); px.className = 'fixa__pix';
    pd.appendChild(p3); pd.appendChild(px);
    fixa.insertBefore(ob, faixa); fixa.insertBefore(pd, faixa);
    var sinc = function(){
      var a = document.getElementById('tp-p1'), b = document.getElementById('tp-p2');
      p3.textContent = a ? a.textContent : ''; px.innerHTML = b ? b.innerHTML : '';
    };
    sinc();
    var pr = document.querySelector('#pg-pdp .tp-pr');
    if(pr && window.MutationObserver) new MutationObserver(sinc).observe(pr, { subtree: true, childList: true, characterData: true });
  }
})();
